<template>
  <div class="message-wrapper">
    <!-- Bot Messages (shown first) -->
    <div
      v-for="(document, index) in message.bot?.documents || []"
      :key="`bot-${index}`"
      class="message-container bot-message"
    >
      <div v-if="botAvatar" class="message-avatar">
        <img :src="botAvatar" :alt="botAvatarAlt" class="avatar-image" />
      </div>
      <div class="message-content">
        <span v-html="document.abstract"></span>
      </div>
    </div>

    <!-- User Message (shown after bot) -->
    <div v-if="message.user" class="message-container user-message">
      <div class="message-content">
        <span>{{ message.user }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatMessage',
  props: {
    message: {
      type: Object,
      required: true,
      validator: (value) => {
        return value.user !== undefined || value.bot !== undefined;
      },
    },
    botAvatar: {
      type: String,
      default: null,
    },
    botAvatarAlt: {
      type: String,
      default: 'Bot avatar',
    },
  },
};
</script>

<style scoped>
.message-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.message-container {
  margin: 1vh 1vw;
  padding: 15px;
  border-radius: 24px;
  display: inline-flex;
  align-items: stretch;
  max-width: 80%;
  width: fit-content;
}

.user-message {
  background-color: #fff;
  border: solid 1px #0B385B;
  justify-content: flex-end;
  margin-left: auto;
  margin-right: 1vw;
}

.bot-message {
  background-color: #01c5ae50;
  border: solid 1px #0B385B;
  justify-content: flex-start;
  margin-right: auto;
  margin-left: 1vw;
}

.message-avatar {
  display: flex;
  align-items: flex-start;
  margin-right: 2vw;
  flex-shrink: 0;
}

.avatar-image {
  width: 3vw;
  border-radius: 2vw;
}

.message-content {
  word-wrap: break-word;
  min-width: 0;
}

.user-message .message-content {
  text-align: right;
}

.user-message .message-content > * {
  display: block;
  text-align: justify;
  text-align-last: right;
}

.bot-message .message-content {
  text-align: left;
}

.bot-message .message-content > * {
  display: block;
  text-align: justify;
  text-align-last: left;
}

.message-content :deep(a) {
  color: #01C5AD;
}

.message-content :deep(code) {
  background-color: #f4f4f4;
  padding: 2px 4px;
  border-radius: 3px;
  font-family: monospace;
}

@media only screen and (max-width: 600px) {
  .avatar-image {
    width: 5vh;
    border-radius: 3vh;
    margin-right: 2vh;
  }
}
</style>

